import * as pc from 'playcanvas';
import gsap from 'gsap';
const IRWNCamera = {
  Params: {
    rangeX: 0.1,
    rangeY: 0.1,
    targetX: 0.5,
    targetY: 0.5,
    inertia: 200,
    distance: 7,
    lookX: 0,
    lookY: 0,
    lookZ: 0,
    fov: 35,
  },
  init: function(cam, e_cam, appJson) {
    this.cam = cam;
    this.e_cam = e_cam;
    this.currentX = 0.5;
    this.currentY = 0.5;

    // setup from appJson
    const P = this.Params;
    P.rangeX = appJson.rangeX;
    P.rangeY = appJson.rangeY;
    P.inertia = appJson.inertia;
    P.distance = appJson.distance;
    P.lookat = appJson.lookat;
    P.lookX = appJson.lookat.x;
    P.lookY = appJson.lookat.y;
    P.lookZ = appJson.lookat.z;
    P.fov = appJson.fov;
    this.cam.fov = P.fov;
  },
  update: function(dt) {
    const P = this.Params;
    const thetaOffset = Math.PI * 0.5;
    this.currentX += (P.targetX - this.currentX) / P.inertia;
    this.currentY += (P.targetY - this.currentY) / P.inertia;

    const thetaX = (-P.rangeX + (this.currentX * P.rangeX * 2)) + thetaOffset;
    const thetaY = (-P.rangeY + (this.currentY * P.rangeY * 2)) + thetaOffset;
    const posX = Math.cos(thetaX) * P.distance;
    const posY = Math.cos(thetaY) * P.distance;
    const posZ = Math.sin(thetaX) * P.distance;
    this.e_cam.setLocalPosition(posX, posY, posZ);
    this.e_cam.lookAt(P.lookX, P.lookY, P.lookZ);
  },
  setTarget: function(x, y) {
    IRWNCamera.Params.targetX = x;
    IRWNCamera.Params.targetY = y;
  },
  SetLookat: function(x, y, z) {
    this.Params.lookat.x = x;
    this.Params.lookat.y = y;
    this.Params.lookat.z = z;
  },
  setFov: function(fov) {
    this.Params.fov = fov;
    this.cam.fov = fov;
  },
  setDistance: function(value) {
    this.Params.distance = value;
  },
  goto: function(lookX, lookY, lookZ, distance, fov, duration=4, ease = 'expo.inOut') {
    gsap.killTweensOf(this.Params);
    gsap.to(this.Params, {
      lookX: lookX,
      lookY: lookY,
      lookZ: lookZ,
      distance: distance,
      fov: fov,
      duration: duration,
      ease: ease,
      callbackScope: this,
      onUpdate: this.onTweenUpdate,
    });
  },
  onTweenUpdate: function() {
    this.cam.fov = this.Params.fov;
  },
};
export {IRWNCamera};
